module.exports = __webpack_public_path__ + "img/icon-printer.2466c71d.svg";